import { useCallback, useEffect, useState } from "react";
import axios from "../../api/axios";
import useAuth from "../../hooks/useAuth";

const WEBSITE_URL = "/image_url";

export default function PhotoCarousel({ title }) {
  const galleryTitle = "gallery-" + title;
  const { username } = useAuth();

  const [images, setImages] = useState([]);
  const [idx, setIdx] = useState(0);

  const loadImages = useCallback(async () => {
    try {
      const res = await axios.get(WEBSITE_URL + "/gallery", {
        params: { title: galleryTitle, username }
      });

      if (res.data && res.data.length > 0) {
        setImages(res.data.slice(0, 4));
      }
    } catch (err) {
      console.error(err);
    }
  }, [galleryTitle, username]);

  useEffect(() => {
    loadImages();
  }, [loadImages]);

  useEffect(() => {
    const timer = setInterval(() => {
      setIdx(prev => (prev + 1) % images.length);
    }, 9000);

    return () => clearInterval(timer);
  }, [images]);

  const goNext = () => setIdx((idx + 1) % images.length);
  const goPrev = () => setIdx((idx - 1 + images.length) % images.length);

  if (images.length === 0) return null;

  return (
    <div className="slow-photo-carousel">

      {images.map((img, i) => (
        <div
          key={i}
          className={i === idx ? "slow-carousel-slide active" : "slow-carousel-slide"}
        >
          <img src={img.url} alt="carousel" className="carousel-img" />
        </div>
      ))}

      <button className="carousel-arrow left" onClick={goPrev}>
        ❮
      </button>

      <button className="carousel-arrow right" onClick={goNext}>
        ❯
      </button>

      <div className="carousel-dots">
        {images.map((_, i) => (
          <div
            key={i}
            className={`carousel-dot ${i === idx ? "active" : ""}`}
            onClick={() => setIdx(i)}
          ></div>
        ))}
      </div>
    </div>
  );
}
